import React, {useEffect} from 'react';

import {useApi} from "../../../providers/ApiProvider";
import BusinessesModel from "../../../models/BusinessesModel";
import {useBreadcrumbs} from "../../../providers/BreadcrumbsProvider";
import BusinessesReviewCard from "./BusinessesReviewCard";
import {useTranslation} from "react-i18next";
import {useTranslation as useMyTranslation} from "../../../providers/TranslationProvider";
import Pagination from "../../ui/Pagination";
import SimpleCardContainer from "../../ui/SimpleCardContainer";

function BusinessesReviewsAll({}) {
    const {language} = useMyTranslation();
    const { t} = useTranslation();
    const apiContext = useApi();
    const businessesModel = new BusinessesModel(apiContext.api);


    const breadcrumbs = useBreadcrumbs();
    const [reviews, setReviews] = React.useState([]);

    const urlParams = new URLSearchParams(window.location.search);
    const defaultPage = urlParams.get('page') ?? 1;
    const [loading, setLoading] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(defaultPage);
    const [totalPages, setTotalPages] = React.useState(1);
    const pageSize = 15;


    const fetchReviews = () => {
        setLoading(true);

        businessesModel.getReviewsAll(currentPage, pageSize).then((response) => {
            if (response !== false) {
                setReviews(response.reviews);

                setTotalPages(response.total_pages);
            }
        }).finally(() => {
            setLoading(false);
        });
    }


    const setMetaData = (profile) => {
        breadcrumbs.update({
            title: t('All Reviews Feed'),
            breadcrumbs: [
                {label: t('All Reviews Feed')},
            ]
        });

        document.title = t('All Reviews Feed')+' | LocalBoost';
    }


    useEffect(() => {
        setMetaData();
        fetchReviews();
    }, [language]);


    return (
        <SimpleCardContainer title={t('All Reviews Feed')} loading={loading}>
            {reviews.length ? (<>
            <div className={'row'}>
                {reviews.map((review, index) => {
                    return (
                        <div className={'col-lg-6 col-xxl-4'} key={'review-'+index}><BusinessesReviewCard data={review} showBusinessName={true} /></div>
                    );
                })}
            </div>

            <div className="my-3">
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={(page) => {
                        let newUrl = window.location.pathname;
                        if (page > 1) {
                            newUrl += '?page=' + page;
                        }

                        window.location.href = newUrl;
                    }}
                />
            </div>
            </>) : (
                <div className="alert alert-muted">
                    <div className="d-flex align-items-center">
                        <div className="flex-shrink-0">
                            <i className="ti ti-alert"></i>
                        </div>
                        <div className="flex-grow-1 ms-3">
                            <p className="mb-0">
                                {t('No reviews available.')}
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </SimpleCardContainer>
    );
}

export default BusinessesReviewsAll;
